import {inject, InjectionToken, ModuleWithProviders, NgModule, provideAppInitializer} from '@angular/core';

import {AuthenticatedDirective, GameMasterDirective} from './directives';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {JwtInterceptor} from './jwt.interceptor';
import {AuthService} from './auth.service';

// export const AUTH_INITIALIZED = new InjectionToken<Promise<void>>('AUTH_INITIALIZED');

@NgModule({
    imports: [
        AuthenticatedDirective,
        GameMasterDirective
    ],
    exports: [
        AuthenticatedDirective,
        GameMasterDirective
    ],
    providers: [
        provideAppInitializer((): Promise<void> => {
            const authService: AuthService = inject(AuthService);
            return authService.initialize();
        }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        }
    ]
})
export class AuthLibModule {
    static forRoot(): ModuleWithProviders<AuthLibModule> {
        return {
            ngModule: AuthLibModule
        };
    }
}
